import "./Resume.style.css";
import ResumeCard from "./ResumeCard.component";
const Resume = () => {
  const educationData = [
    {
      title: "Bachelor of Informatics",
      year: "2011 - 2016",
      schoolName: "Faculty of Information and Communication Technologies",
      subTitle: "Acquired skills and competencies:",
      more: ["Programming", "Computer Networks", "Office Applications"],
    },
    {
      title: "JavaScript Academy - MERN Stack",
      year: "2020 - 2021",
      schoolName: "Semos Education",
      subTitle: "Acquired skills and competencies:",
      more: [
        "HTML/CSS",
        "JavaScript",
        "React.js",
        "Node.js",
        "Express.js",
        "MongoDB",
        "Third-party APIs",
        "Linux environment",
        "Git",
        "Postman",
      ],
    },
  ];
  const expData = [
    {
      title: "Full Stack Developer",
      year: "2021 - Present",
      schoolName: "Pabau Clinic Software",
      subTitle: "Description",
      more: [
        "Working with TypeScript on a Next.js React framework",
        "Integrating GraphQL apis",
        "Extending and reusing components from ant.design",
        "Writing React components from scratch designed in figma",
        "Writing storybook UI components",
      ],
    },
    {
      title: "Developer",
      year: "2020 - 2021",
      schoolName: "Digital Office by INBOX archive and data center",
      subTitle: "Description",
      more: [
        "Writing new React components and refactoring old code",
        "Creating PowerShell scripts for API integration",
        "Creating JSON data using Postman for our mobile app",
        "Optimization and digitalization of business processes",
        "Creating BPMN diagrams",
        "Client Communication",
      ],
    },
    {
      title: "Intern",
      year: "2019 - 2020",
      schoolName: "Digital Office by INBOX archive and data center",
      subTitle: "Description",
      more: [
        "Optimization and digitalization of business processes.",
        "Creating BPMN diagrams.",
      ],
    },
  ];
  return (
    <section className="section-title section-container" id="resume">
      <h2>Resume</h2>
      <div className="resume-container">
        <div className="education-container">
          <h3 className="resume-title">Education</h3>

          {educationData.map((item, i) => (
            <ResumeCard
              eduTitle={item.title}
              year={item.year}
              schoolName={item.schoolName}
              subTitle={item.subTitle}
              skills={item.more}
              key={i}
            />
          ))}
        </div>
        <div className="proffesional-exp">
          <h3 className="resume-title">Professional Experience</h3>

          {expData.map((item, i) => (
            <ResumeCard
              eduTitle={item.title}
              year={item.year}
              schoolName={item.schoolName}
              subTitle={item.subTitle}
              skills={item.more}
              key={i}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Resume;
